module.exports = __webpack_public_path__ + "static/media/empty_service.955aa454.svg";